export const GET_AD_NETWORKS_TYPES = 'PARTNERS_PROGRAM/GET_AD_NETWORKS_TYPES'
export const CALCULATE_AWARDS = 'PARTNERS_PROGRAM/CALCULATE_AWARDS'
export const SET_AD_NETWORKS_TYPES = 'PARTNERS_PROGRAM/SET_AD_NETWORKS_TYPES'
export const RESET_AD_NETWORKS_TYPES =
  'PARTNERS_PROGRAM/RESET_AD_NETWORKS_TYPES'
export const SET_CALCULATE_AWARDS = 'PARTNERS_PROGRAM/SET_CALCULATE_AWARDS'
export const RESET_CALCULATE_AWARDS = 'PARTNERS_PROGRAM/RESET_CALCULATE_AWARDS'
